module.exports = __webpack_public_path__ + "img/coupon management.b272aa47.svg";